export default __webpack_public_path__ + "locales/ro/OAuth.json?hash=8611fd50c52c0bbbe2ae3bcf38310c02";